import { render, staticRenderFns } from "./RolePermissionsTable.vue?vue&type=template&id=2259c0a1&scoped=true&"
import script from "./RolePermissionsTable.vue?vue&type=script&lang=js&"
export * from "./RolePermissionsTable.vue?vue&type=script&lang=js&"
import style0 from "./RolePermissionsTable.vue?vue&type=style&index=0&id=2259c0a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2259c0a1",
  null
  
)

export default component.exports